import { faQuoteLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DotNavigator from "app/components/WeeklyCheckInComponents/DotNavigator";
import {
  getSkillGuide,
  selectSkillsGuide,
} from "app/containers/SkillsGuide/slice";
import React, { useEffect, useMemo, useState } from "react";
import { Card } from "react-bootstrap";
import { useAppDispatch, useAppSelector } from "utils/redux/hooks";

const TodaysMantraCard = () => {
  const dispatch = useAppDispatch();
  const skillGuide = useAppSelector(selectSkillsGuide);
  const [activeStep, setActiveStep] = useState(0);
  useEffect(() => {
    dispatch(getSkillGuide());
  }, [dispatch]);

  const randomQuotes = useMemo(() => {
    // Strategy for this memo, is to store all of the quotes in array and then pull 3 random quotes from that array
    let quotes: string[] = [];
    if (Object.keys(skillGuide).length === 0) {
      return [];
    }
    for (const factor of Object.values(skillGuide)) {
      for (const construct of Object.values(factor)) {
        for (const skill of Object.values(construct)) {
          quotes.push(skill.quote);
        }
      }
    }
    const randomQuotes = [];
    for (let i = 0; i < 3; i++) {
      const randomIndex = Math.floor(Math.random() * quotes.length);
      randomQuotes.push(quotes[randomIndex]);
      quotes.splice(randomIndex, 1);
    }
    return randomQuotes;
  }, [skillGuide]);

  return (
    <Card className="today-mantra-card">
      <div className="row-gap-8px align-items-center">
        <div className="circle-icon-container">
          <FontAwesomeIcon icon={faQuoteLeft} />
        </div>
        <h3>Today's Quote</h3>
      </div>
      <p>{randomQuotes[activeStep]}</p>
      <DotNavigator
        activeStep={activeStep}
        totalSteps={randomQuotes.length}
        onStepChange={(step) => setActiveStep(step)}
      />
    </Card>
  );
};

export default TodaysMantraCard;
